<template>
    <div>
        <BaseListPage
            headline="lang_AZ_SOCIETIES"
            :context="context"
            :alvqa="alvqa"
        >
        <!-- DATA TABLE COMPONENT -->
            <template v-slot:dataTable>
                <BaseDataTableList
                    :headers="headers"
                    :context="context"
                    :alvqa="alvqa"
                >
                <!-- TOPSLOT: actions, imports etc. -->
                    <template v-slot:topSlot><AzSocietiesTopSlot /></template>
                <!-- DATA TABLE CONTENT: columns -->
                    <template v-slot:body="{ item }">

                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        />

                        <td>
                            <v-img 
                                v-if="item.item.picture !== undefined && item.item.picture !== null"
                                :src="item.item.picture"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                                width="40px"
                            ></v-img>
                            <v-img 
                                v-else
                                :src="require('@/assets/default_picture/default.jpg')"
                                :alvqa="alvqa + '-list-row-' + item.item.alvId + '-image'"
                                width="40px"
                            ></v-img>
                        </td>
                        <td class="ellipsis">
                            <BaseTooltip
							  :simpleText="item.item.name"
                              :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-name'"
                            />
                        </td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-city'">
							{{ item.item.city }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-country'">
							{{ getCountry(item.item.country) }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-acronym'">
							{{ item.item.societyAcronym }}
						</td>
                        <td 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-society-code'"
                            align="right"
                        >
							{{ getSocietyCode(item.item.societyCode) }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.alvId + '-text-alv-id'">
                            {{ item.item.alvId }}
                        </td>
                    </template>

                    <template v-slot:expandSlot><AzSocietiesReadOnly /></template>  
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ExpandIcon from '@/components/_buttons/ExpandIcon'
import AzSocietiesReadOnly from './_readonly/AzSocietiesReadOnly'
import AzSocietiesTopSlot from './AzSocietiesTopSlot'

export default {
    name: "AzSocietiesList",
    components: {
        BaseListPage,
        BaseDataTableList,
        BaseTooltip,
        ExpandIcon,
        AzSocietiesTopSlot,
        AzSocietiesReadOnly
    },
    data() {
        return {
            context: "AzSocieties",
            alvqa: "az-societies"
        }
    },
    computed: {
        headers() {
            return [
                {
					text: '', 
					value: 'data-table-select', 
					align: 'center',
					width: "60px",
                    sortable: false,
					class: 'text-no-wrap'
                },
                { // column 02: Read-only view
                    text: '', 
                    value: 'data-table-expand',
                    align: 'center', 
                    width: "48px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: '', 
                    value: 'picture', 
                    align: 'center',
                    width: "65px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_SOCIETY'), 
                    value: 'name',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_CITY'), 
                    value: 'city',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_COUNTRY'), 
                    value: 'country',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                }, 
                {
                    text: this.$t('lang_AZ_SOCIETIES_ACRONYM'), 
                    value: 'societyAcronym',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_CODE'), 
                    value: 'societyCode',
                    align: 'right', 
                    sortable: false, 
                    width: "75px",
                    class: 'text-no-wrap'
                },
				{
					text: this.$t('lang_CAPTION_ALVID'),
					value: 'alvId', 
					align: 'left', 
					sortable: false,
					width: "170px",
					class: 'text-no-wrap'
				},
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
            ]
        }
    },
    methods: {
        getCountry(countryCode) {            
            return this.$alvPlugin.getTranslatedCountryName(countryCode, true)
        },
        getSocietyCode(code) { // show 3 digits with leading zeroes for CISAC society codes
            if (code) return code.toString().padStart(3, "0");
        }
    },
    mounted() {
        this.$store.commit('setCountries')
    }
}
</script>